import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import XIcon from '@heroicons/react/outline/XIcon';
import { useMedia } from '@tribeplatform/react-sdk/hooks';
import { SpinnerIcon } from '@tribeplatform/react-ui-kit/icons';
import { Tooltip } from '@tribeplatform/react-ui-kit/Tooltip';
import { FileListItem } from '../../../common/components/FileListItem';
import { T } from '../../../i18n';
import { Container } from '../Container';
export const AttachmentNodeView = props => {
    const { node, deleteNode, getPos, editor } = props;
    const initialData = node.attrs.attachment;
    const attachmentId = (initialData === null || initialData === void 0 ? void 0 : initialData.id) || node.attrs.id;
    const { data: media } = useMedia({
        variables: {
            id: attachmentId,
        },
        fields: {
            onFile: 'basic',
        },
        useQueryOptions: {
            initialData,
            cacheTime: Infinity,
            staleTime: Infinity,
            enabled: !!attachmentId,
        },
    });
    if (!media && !attachmentId) {
        return (_jsx(Container, { ...props, children: _jsx(T, { id: "Generics.SomethingWentWrong", defaultMessage: "Something went wrong" }, void 0) }, void 0));
    }
    const attachment = media;
    const onRemove = () => {
        const position = getPos() - 2;
        const { url } = attachment;
        deleteNode();
        editor
            .chain()
            .focus(position)
            .insertLink({ href: url })
            .insertContent(' ')
            .run();
    };
    return (_jsx(Container, { ...props, children: _jsx(FileListItem, { name: attachment === null || attachment === void 0 ? void 0 : attachment.name, extension: attachment === null || attachment === void 0 ? void 0 : attachment.extension, size: attachment === null || attachment === void 0 ? void 0 : attachment.size, action: _jsxs("div", { className: "flex items-center space-s-3", children: [(attachment === null || attachment === void 0 ? void 0 : attachment.isLoading) && (_jsx(SpinnerIcon, { className: "animate-spin w-7 h-7" }, void 0)), _jsxs(Tooltip, { children: [_jsx(Tooltip.Trigger, { children: _jsx(XIcon, { onClick: onRemove, className: "text-content-subdued hover:text-content-hovered cursor-pointer w-6 h-6" }, void 0) }, void 0), _jsx(Tooltip.Panel, { children: _jsx(T, { id: "Generics.Delete", defaultMessage: "Delete" }, void 0) }, void 0)] }, void 0)] }, void 0) }, void 0) }, void 0));
};
//# sourceMappingURL=AttachmentNodeView.js.map